import React, { ReactNode } from 'react';
import {
  SignalWifi1Bar,
  SignalWifi2Bar,
  SignalWifi3Bar,
  SignalWifi4Bar,
  SignalWifiOff,
} from '@material-ui/icons';
import './WifiSignal.scss';

// Backend provides signalQuality: 5=Excellent, 4=VeryGood, 3=Good, 2=Fair, 1=Poor, 0=Unusable
export const getWifiSignalIcon = (
  signalQuality: number | undefined,
  connected: boolean | undefined = true
): ReactNode => {
  if (!connected || signalQuality === undefined) {
    return <SignalWifiOff className="signalStrength0" />;
  }

  if (signalQuality >= 4) {
    return <SignalWifi4Bar className="signalStrength4" />;
  }
  if (signalQuality === 3) {
    return <SignalWifi3Bar className="signalStrength3" />;
  }
  if (signalQuality === 2) {
    return <SignalWifi2Bar className="signalStrength2" />;
  }
  if (signalQuality === 1) {
    return <SignalWifi1Bar className="signalStrength1" />;
  }
  return <SignalWifiOff className="signalStrength0" />;
};

// Scanned networks only expose rssi (dBm), so map it onto the same signalQuality
// scale used for the connected network. A detected network always keeps at least
// one bar, even when rssi is missing.
export const rssiToSignalQuality = (rssi: number | undefined): number => {
  if (rssi === undefined) {
    return 3;
  }

  const dbm = rssi <= 0 ? rssi : -rssi;

  if (dbm >= -55) {
    return 4;
  }
  if (dbm >= -65) {
    return 3;
  }
  if (dbm >= -75) {
    return 2;
  }
  return 1;
};
